import React, {Component} from 'react'
import { connect } from 'react-redux'

import Container from 'ui/Container'
import Button from 'ui/Button'

import {
  millisToMinutesSeconds
} from '../../helpers/TimeHelper'

class OverlayPlayerClass extends Component{

  constructor(props){
    super(props)
    this.display = {
      classType:{
        1:'hotpod',
        2:'nurturing',
        3:'dynamic'
      },
      duration:{
        1:'1 hour class',
        2:'45 minute class'
      }
    }
  }

  getTimeline(){
    const {data} = this.props
    return data.map((schedule,index) => {
      const style = {
        left:this.calculateMarkerPos(schedule),
        display:index === 0 ? 'none' : 'initial'
      }
      return (
        <div key={index} className="timeline-marker" style={style}>
          <span>marker</span>
        </div>
      )
    })
  }

  calculateMarkerPos(schedule){
    const start = schedule.start.split(':')
    const pos = (start[1]/(this.props.classTypes.duration === 1 ? 60 : 45))*100
    return pos+'%'
  }

  getScrubber(){
    const style = {
      width:this.calculateScrubber()
    }
    return(
      <div className="scrubber-time" style={style}></div>
    )
  }

  calculateScrubber(){
    const {currClassTime, classTypes} = this.props
    const width = (currClassTime/(classTypes.duration === 1 ? 3600000 : 2700000))*100
    return width+'%'
  }

  render(){
    const {
      track,
      classTypes,
      currPlaylist,
      currClassTime
    } = this.props

    return (
      <div className="overlay-player-class">
        <div className="class-title">
          <div className="type">{this.display.classType[classTypes.classType]} flow</div>
          <div className="duration">{this.display.duration[classTypes.duration]}</div>
        </div>
        <div className="scrubber-wrapper">
          <div className="scrubber">
            <div className="scrubber-track"></div>
            {this.getScrubber()}
            {this.getTimeline()}
            <div className="time curr-time">{millisToMinutesSeconds(currClassTime)}</div>
            <div className="time total-time">{classTypes.duration === 1 ? '60:00' : '45:00'}</div>
          </div>
          <div className="playlist-name">{currPlaylist ? currPlaylist.name : ''}</div>
        </div>
        <div className="track-display">
          <div className="track-title">{track ? track.title : ''}</div>
          <div className="track-artist">{track ? track.artist : ''}</div>
        </div>
      </div>
    )
  }
}
function mapStateToProps(store){
  return {
    track:store.player.currTrack,
    classData:store.player.classData,
    classTypes:store.player.classTypes,
    currPlaylist:store.player.currPlaylist,
    currClassTime:store.player.currClassTime
  }
}
export default connect(mapStateToProps)(OverlayPlayerClass)


// WEBPACK FOOTER //
// ./src/components/overlay/OverlayPlayerClass.js